import { render } from "./ProductsSelected.vue?vue&type=template&id=9aa9c3aa&scoped=true"
import script from "./ProductsSelected.vue?vue&type=script&lang=js"
export * from "./ProductsSelected.vue?vue&type=script&lang=js"

import "./ProductsSelected.vue?vue&type=style&index=0&id=9aa9c3aa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa9c3aa"]])

export default __exports__